import { useTranslation } from 'react-i18next'
import type { RiskReductionMeasure } from '@/shared/hooks/api/machineryDirectiveCompliance'
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemTitle,
} from '@/components/ui/item'
import { PlrCircleBadge } from '../../components/PlrCircleBadge'
import {
  isSafetyFunctionMeasure,
  showsPlrTbdEmptyState,
} from './riskReductionMeasuresUtils'

type RiskReductionMeasurePlrDisplayProps = {
  riskReductionMeasure: RiskReductionMeasure
  variant: 'card' | 'detail'
}

export function RiskReductionMeasurePlrDisplay({
  riskReductionMeasure,
  variant,
}: RiskReductionMeasurePlrDisplayProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  if (!isSafetyFunctionMeasure(riskReductionMeasure)) {
    return null
  }

  if (showsPlrTbdEmptyState(riskReductionMeasure)) {
    if (variant === 'card') {
      return (
        <div className='flex max-w-[10rem] flex-col items-center justify-center gap-1 text-center md:items-end md:text-right'>
          <div className='text-sm font-semibold text-muted-foreground'>
            {t('riskReductionMeasuresLibraryPage.plrTbd.title')}
          </div>
          <p className='text-xs text-muted-foreground'>
            {t('riskReductionMeasuresLibraryPage.plrTbd.description')}
          </p>
        </div>
      )
    }

    return (
      <Item variant='outline' size='sm'>
        <ItemContent>
          <ItemTitle>
            {t('riskReductionMeasuresLibraryPage.plrTbd.title')}
          </ItemTitle>
          <ItemDescription>
            {t('riskReductionMeasuresLibraryPage.plrTbd.description')}
          </ItemDescription>
        </ItemContent>
      </Item>
    )
  }

  if (variant === 'card') {
    return (
      <div className='flex items-center justify-center gap-2 md:flex-col md:gap-0'>
        <div className='mb-1 text-center text-sm font-semibold text-muted-foreground md:text-right'>
          PLr
        </div>
        <PlrCircleBadge plr={riskReductionMeasure.plr} />
      </div>
    )
  }

  return (
    <Item variant='outline' size='sm'>
      <ItemContent>
        <ItemTitle>PLr</ItemTitle>
      </ItemContent>
      <ItemActions>
        <PlrCircleBadge plr={riskReductionMeasure.plr} />
      </ItemActions>
    </Item>
  )
}
